import axios from "axios";
import Vue from "vue";
import store from "./store";
import i18n from "./i18n";
import { disconnectWS } from "@/plugins/websocket";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL || "/api"
});

interface ErrorResponse {
  status: string;
}
function mergeErrorMessages(res: Array<ErrorResponse>) {
  return res.map(item => i18n.t(item.status)).join("\n");
}

http.interceptors.request.use(
  function(config) {
    if (Vue.cookies.get("token")) {
      config.headers["Authorization"] = `Bearer ${Vue.cookies.get("token")}`;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  res => {
    if (res.data.token) {
      Vue.cookies.set("token", res.data.token);
      Vue.cookies.set("name", res.data.name);
      Vue.cookies.set("notification", res.data.notification);
    }
    return res;
  },
  err => {
    if (err.response.status === 400) {
      store.dispatch("snackbar/openSnackbar", {
        msg: mergeErrorMessages(err.response.data),
        color: "error"
      });
    } else if (err.response.status === 401) {
      Vue.cookies.remove("token");
      Vue.cookies.remove("notification");
      disconnectWS();
      store.commit("user/clearUser");
      store.commit("user/clearMessage");
      //this.$router.push(`/${this.$i18n.locale}`);
    }
    return Promise.reject(err);
  }
);

export default http;
